import axios from 'axios'
import router from './router/index.js'

export default {
    data(){
        return {
            loading : false,
            modelName : null,
            data: null,
            redirectToList: true
        };
    },
    methods: {
        // Id numarası verilen kaydı çekerek 'data' değişkenine atar. Varsa hata bildirimlerini yapar, loading vs. yönetir
        // replaceRouter: Yüklenen kaydın Id'si routerda değiştirilsin mi? EYP formu gibi iç formlar URL'de değişiklik yapmaz.
        // Bu gibi durumlarda false geçilmelidir.
        getData(id, kind = null){
            this.loading = true;
            var url = `/${this.modelName}/get/${id}`;

            if(id == window.emptyObjectId && kind)
                url += '?kind=' + kind;

            return axios
              .get(url)
              .then(x => {
                console.log("PSOT Result:", x.data);
                this.data = x.data;
                this.loading = false;
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        save(){
            this.loading = true;
            this.errorMessage = null;
            return axios
              .post(`/${this.modelName}/post/${this.data.Id}`, this.data)
              .then(x => {
                console.log("PSOT Result:", x.data);
                if(x.data.Success) {
                    if(this.redirectToList) {
                        this.$router.push({ name:this.modelName + 'List' });
                    } else {
                        if(this.data.Id == window.emptyObjectId) {
                            router.replace({ params: { id: this.data.Id } });
                        }

                        this.data = x.data.Data;
                    }
                } else {
                    alert(x.data.ErrorMessages);
                    this.errorMessage = x.data.ErrorMessages;
                }
                this.loading = false;
                return x;
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        async getCirculationProfileSchemas(){
            const {data} = await axios.post("circulationprofileschema/get");
            return data;
        },
        async getUsers(){
            const {data} = await axios.post("user/get");
            return data;
        },
        async getDepartments(){
            const {data} = await axios.post("department/get");
            return data;
        },
        async getTitles(){
            const {data} = await axios.post("title/get");
            return data;
        },
        async getTargetSystems(){
            const {data} = await axios.post("targetsystem/get");
            return data;
        },
        async getOzne(){
            const {data} = await axios.post("ozne/get");
            return data;
        },
        async getAuthorizationDefinitions(){
            const {data} = await axios.get("user/getAuthorizationDefinitions");
            return data;
        },
    }
}